export default __webpack_public_path__ + "static/media/calculator.1b4db011.PNG";